import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import LogoBranco from '../../assets/svg/LogoBranco.svg';

const LoginSidebar = () => {
  const { theme, tenantTheme } = useTheme();
  const logoSrc = tenantTheme?.logo || LogoBranco;
  
  const metrics = [
    {
      title: 'Receita Mensal',
      value: 'R$ 1.2M',
      type: 'chart',
      data: [40, 70, 50, 100, 60]
    },
    {
      title: 'Clientes Ativos', 
      value: '2,847',
      type: 'progress',
      progress: 75
    },
    {
      title: 'Integrações Ativas',
      type: 'integrations',
      count: 3,
      extra: '+5 mais'
    }
  ];

  const features = [
    'Gestão Financeira Inteligente',
    'Integrações Automáticas', 
    'Relatórios Personalizados'
  ];

  return (
    <div style={{
      width: '50%',
      background: `${theme.primary}`,
      display: 'flex',
      flexDirection: 'column',
      color: theme.white,
      position: 'relative',
      alignItems: 'center',
      justifyItems: 'center'
    }}>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <img src={logoSrc} alt="Logo" style={{ width: '75%', height: '75%', objectFit: 'contain' }} />
      </div>
  
    </div>
  );
};

export default LoginSidebar; 